module.exports = __webpack_public_path__ + "img/QueXian01.bcce2bd7.png";